import createApplication from './createApplication.js'

createApplication().mount('#appVue')
